@if (document && userAccount) {
  <div [style.padding-bottom.px]="bottom_bar.offsetHeight">
    <div class="mt-4 font-14">
      <div>File Details</div>
      <table class="font-grey">
        <tr>
          <td>File Type</td>
          <td>PDF</td>
        </tr>
        <tr>
          <td>Size</td>
          <td>
            {{
              $safeNavigationMigration(document?.fileSize) / 1000
                | number: "1.0-0"
            }}KB
          </td>
        </tr>
      </table>
    </div>
    @if (formFields) {
      <div class="fields-box">
        <app-edit-fields
          [formFields]="formFields"
          [patient]="patient"
          [formSubmitInfo]="formSubmitInfo"
          [type]="'document'"
          [file_id]="document.id"
          [editMode]="
            document.creator.userId === userAccount.userId ? true : false
          "
          (update)="onDocumentDataUpdate($event)"
        ></app-edit-fields>
      </div>
    }
    <div class="mt-4">
      <div class="font-14">Patient Details</div>
      <app-edit-patient
        [patient]="patient"
        [canSave]="true"
        [editMode]="
          document.creator.userId === userAccount.userId ? true : false
        "
        [alignment]="'vertical'"
        (patientSave)="onPatientSave($event)"
      ></app-edit-patient>
    </div>
    <div class="mt-4">
      <div class="font-14 mb-1">Shared By</div>
      <app-avatar-with-name
        [title]="$safeNavigationMigration(document?.creator?.title)"
        [firstName]="$safeNavigationMigration(document?.creator?.firstName)"
        [lastName]="$safeNavigationMigration(document?.creator?.lastName)"
        [description]="document.createdOn | dateFormat: 'medium'"
        [userId]="$safeNavigationMigration(document?.creator?.userId)"
        [profilePic]="
          $safeNavigationMigration(document?.creator?.profilePicture)
        "
      >
      </app-avatar-with-name>
    </div>
    <div class="bottom-bar" #bottom_bar>
      @if (isFromLibrary) {
        <button mat-button class="delete" (click)="delete()">
          <i class="material-icons">delete</i>
          Remove document from my library
        </button>
      }
    </div>
  </div>
}
